/**
 * Mapbox UI strings overridden for every map. Mapbox merges these over its defaults.
 *
 * `Map.Title` is the accessible name Mapbox gives the map canvas region. Pages wrap the map in their
 * own labelled region (such as "Map view"), so the canvas gets a distinct name.
 */
export const MAP_LOCALE = { 'Map.Title': 'Interactive map' } as const;
